






























import { Vue, Component, Watch } from 'vue-property-decorator'
import { Button, Header, Container, Logo, InputError, BackButton } from '../atoms/'
import { InputGroup, PasswordInputGroup } from '../molecules'
import { required, sameAs, minLength } from 'vuelidate/lib/validators'
import { mapGetters, mapActions } from 'vuex'
import { REGISTER, EMAIL_SERVER_ERROR } from '../../store/modules/register/constant'
import { RESET_PASSWORD, USER_MODULE, RESET_PASSWORD_LANDING } from '../../store/modules/user/constant'
import { passwordRequired, passwordMinLength, passwordMismatch, wrongPasswordPattern, oldPasswordDuplicated } from '../../utils/errors'
import { passwordPattern } from '../../utils/validators'
import { PASSWORD_FIELD_LIMIT } from '../../utils/field-length'
import { AUTH_MODULE, EMAIL_LOGIN, SET_FORGOT_EMAIL_LOGIN } from '@/store/modules/auth/constant'
import { APP_MODULE, TRANSLATE } from '@/store/modules/app/constant'
import translate from '@/language'

@Component({
  components: {
    Button,
    Container,
    Header,
    InputGroup,
    PasswordInputGroup,
    Logo,
    InputError,
    BackButton
  },
  validations: {
    password: {
      required,
      minLength: minLength(8),
      passwordPattern
    },
    repeatPassword: {
      required,
      sameAsPassword: sameAs('password')
    }
  },
  methods: {
    ...mapActions(USER_MODULE, [RESET_PASSWORD, RESET_PASSWORD_LANDING]),
    ...mapActions(AUTH_MODULE, [EMAIL_LOGIN, SET_FORGOT_EMAIL_LOGIN])
  },
  computed: {
    ...mapGetters(REGISTER, [EMAIL_SERVER_ERROR]),
    ...mapGetters(APP_MODULE, [TRANSLATE])
  }
})
export default class ResetPassword extends Vue {
  private password?: string = ''
  private repeatPassword?: string = ''
  private email?: string = ''
  private errorMsg = ''

  @Watch('password')
  onPasswordChange() {
    this.$v.password.$touch()
  }
  @Watch('repeatPassword')
  onRepeatPassword() {
    this.$v.repeatPassword.$touch()
  }

  async mounted() {
    this.$nextTick(() => {
      this.$v.$reset()
    })

    const payload = {
      cipher: this.$route?.query.q as string,
      password: this.password,
      confirm_password: this.repeatPassword
    }
    const resp = await (this as any)[RESET_PASSWORD_LANDING](payload)
    if (resp.code === 200) {
      this.email = resp.data.email
    }
    if (resp?.code === 400) {
      this.$router.push({
        path: '/reset-password-expired',
        query: { email: this.email, channel: this.$route?.query?.channel }
      })
    } else if (resp?.code >= 500) {
      this.errorMsg = resp?.error_message
    }
  }

  get passwordFieldLimit(): number {
    return PASSWORD_FIELD_LIMIT
  }
  get passwordError(): string {
    const { password } = this.$v
    if (password.$error) {
      if (!password.required) {
        return translate('', 'error-password-required')
      }
      if (!password.minLength) {
        return translate('', 'error-password-min-length')
      }
      if (!password.passwordPattern) {
        return translate('', 'error-password-wrong-pattern')
      }
    }
    return ''
  }
  get repeatPasswordError() {
    const { repeatPassword } = this.$v
    if (repeatPassword.$error) {
      if (!repeatPassword.required) {
        return translate('', 'error-password-required')
      }
      if (!repeatPassword.sameAsPassword) {
        return translate('', 'error-password-mismatch')
      }
    }

    return ''
  }
  get formError(): boolean {
    this.$v.password.$touch()
    this.$v.repeatPassword.$touch()
    this.$v.repeatPassword.$touch()
    return this.passwordError == '' && this.repeatPasswordError == ''
  }
  async submitResetPassword() {
    (this as any)[SET_FORGOT_EMAIL_LOGIN](this.email)
    this.errorMsg = ''
    if (!this.formError) {
      return
    }
    const payload = {
      cipher: this.$route?.query?.q as string,
      password: this.password,
      confirm_password: this.repeatPassword
    }
    const resp = await (this as any)[RESET_PASSWORD](payload)
    if (resp.code === 200) {
      this.$router.push({
        path: '/reset-password-success',
        query: { channel: this.$route?.query?.channel }
      })
    } else {
      if (resp.code !== 500) {
        this.$router.push({
          path: '/reset-password-expired',
          query: { email: this.email, channel: this.$route?.query?.channel }
        })
      } else {
        this.errorMsg = resp?.error_message
      }
    }
  }
  get oldPasswordDuplicatedPrompt(): boolean {
    return this.errorMsg === oldPasswordDuplicated
  }
}
